import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { InputRow, Combobox } from '@/components/ui/form';
    import { useI18n } from 'vue-i18n';
    import { useEmployeesNotInPayrollData } from '@/composables/useEmployeesNotInPayrollData';
    import { Payroll } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AddEmployeeToPayrollForm',
  props: {
    form: {},
    payroll: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const { employees, isLoadingEmployees } = useEmployeesNotInPayrollData(props.payroll.id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(InputRow), {
    form: _ctx.form,
    name: "employee_id",
    label: "payrolls.add_employee_to_payroll.select_employee"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Combobox), {
        modelValue: _ctx.form.employee_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.employee_id) = $event)),
        options: _unref(employees),
        translate: false,
        placeholder: _unref(t)('payrolls.add_employee_to_payroll.select_employee'),
        "label-by": "full_name",
        "value-by": "id",
        loading: _unref(isLoadingEmployees),
        "show-remove-button": false
      }, null, 8, ["modelValue", "options", "placeholder", "loading"])
    ]),
    _: 1
  }, 8, ["form"]))
}
}

})